"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDropDownMenu = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var O = __importStar(require("fp-ts/Option"));
var Option_1 = require("fp-ts/Option");
var function_1 = require("fp-ts/function");
var Icon_1 = require("../Icon");
var Image_1 = require("../Image");
var TextFormatter_1 = require("../TextFormatter");
require("./iconDropDownMenu.css");
var IconDropDownMenu = function (_a) {
    var image = _a.image, open = _a.open, _b = _a.theme, theme = _b === void 0 ? 'primary' : _b, label = _a.label, preLabel = _a.preLabel, onClick = _a.onClick;
    function renderName() {
        return (0, function_1.pipe)(O.fromNullable(label), (0, Option_1.map)(function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "menu-TextFormatter" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ textAlign: "right", fontWeight: "bold", fontSize: "std", borderless: true }, { children: preLabel })), (0, jsx_runtime_1.jsx)(TextFormatter_1.TextFormatter, __assign({ textAlign: "right", fontWeight: "bold", fontSize: "std", borderless: true }, { children: label }))] }) }))); }), O.toNullable);
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "icon-drop-down", onClick: onClick }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "border" }), renderName(), (0, jsx_runtime_1.jsx)("div", __assign({ className: "icon-drop-down-image" }, { children: (0, jsx_runtime_1.jsx)(Image_1.Image, { src: image, size: "sm", circular: true }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "icon-drop-down-arrow ".concat(open ? 'open' : '') }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_arrow_down_dark", theme: theme }) }))] })) })));
};
exports.IconDropDownMenu = IconDropDownMenu;
//# sourceMappingURL=IconDropDownMenu.js.map